// extracted by mini-css-extract-plugin
module.exports = {"modal":"SceneCreationModal_modal__2wMEL","title":"SceneCreationModal_title__25ORH"};